import { useApiClient } from '../context/AppContext'
import { useCallbackRef, useResourceLoader } from '.'
import assetsApi from '../api/assetsApi'
import IResourceLoader from '../types/IResourceLoader'
import { ILoadAssetCategories } from '../types/AssetCategories/ILoadAssetCategories'
import { FetchAssetCategories } from '../types/AssetCategories/FetchAssetCategories'

const useAssetCategories = (
  siteType: string
): [IResourceLoader<Array<string>>, ILoadAssetCategories] => {
  const apiClient = useApiClient()

  const response = useResourceLoader<Array<string>>(
    'Unable to load asset categories'
  )

  const loader = useCallbackRef<FetchAssetCategories>(() =>
    response.load(
      async () =>
        await assetsApi.getAssetCategories(apiClient, siteType)
    )
  )

  return [response, loader]
}

export default useAssetCategories
